<template>
  <b-row>
    <b-col cols="12" xl="6">
      <b-card
        header="میزان مصرف CPU"
        body-class="d-flex justify-content-center"
      >
        <line-chart :chartData="cpuChartData" :options="chartOptions" />
      </b-card>
    </b-col>
    <b-col cols="12" xl="6">
      <b-card
        header="میزان مصرف RAM"
        body-class="d-flex justify-content-center"
      >
        <line-chart :chartData="ramChartData" :options="chartOptions" />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import LineChart from "@/components/Chart/LineChart.vue";
import { SET_STATS } from "@/store/mutation-types.js";

export default {
  name: "AppMonitoring",
  components: { LineChart },
  data() {
    return {
      cpuChartData: null,
      ramChartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                min: 0,
                max: 100
              }
            }
          ]
        }
      },
      counter: 0,
      timerStatsInterval: null
    };
  },
  computed: {
    ...mapState("statsMonitoringApp", [
      "cpuStats",
      "ramStats",
      "loading",
      "errorMessages"
    ])
  },
  created() {
    this.fillData();
    this[SET_STATS](this.$route.params.serviceId);
  },
  mounted() {
    this.timerStatsInterval = setInterval(this.timerStats, 3000);
  },
  methods: {
    ...mapActions("statsMonitoringApp", [SET_STATS]),
    timerStats: function() {
      this.fillData();
      this[SET_STATS](this.$route.params.serviceId);
    },
    fillData: function() {
      const cpuTimes = this.cpuStats.map(d => d.time);
      const cpuData = this.cpuStats.map(d => d.data);
      const ramTimes = this.ramStats.map(d => d.time);
      const ramData = this.ramStats.map(d => d.data);
      this.cpuChartData = {
        labels: cpuTimes,
        datasets: [
          {
            label: "وضعیت پردازنده (CPU)",
            backgroundColor: "#00cf4f",
            data: cpuData
          }
        ]
      };
      this.ramChartData = {
        labels: ramTimes,
        datasets: [
          {
            label: "وضعیت حافظه (RAM)",
            backgroundColor: "#00cf4f",
            data: ramData
          }
        ]
      };
    }
  },
  destroyed() {
    clearInterval(this.timerStatsInterval);
  }
};
</script>

<style lang="scss">
.inner-text-gauge {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  color: #00cf4f;
  & span {
    font-size: 35px;
  }
}
</style>
